import axios from '../axios'

/*
 * 收藏模块
 */

// 查询
export const selectByPage = (data) => {
    return axios({
        url: '/admin/memberFollow/selectByPage',
        method: 'post',
        data
    })
}
export const onSelectByPage = (data) => {
    return axios({
        url: '/admin/balanceRecord/selectByPage',
        method: 'post',
        data
    })
}

//已结算
export const selectCommissionPage = (data) => {
    return axios({
        url: '/admin/member/selectCommissionPage',
        method: 'post',
        data
    })
}

export const selectSettlementedPage = (data) => {
    return axios({
        url: '/admin/member/selectSettlementedPage',
        method: 'post',
        data
    })
}

export const selectUnsettlementPage = (data) => {
    return axios({
        url: '/admin/member/selectUnsettlementPage',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/memberFollow.js